module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(290);


/***/ },

/***/ 3:
/***/ function(module, exports) {

	/* globals __VUE_SSR_CONTEXT__ */

	// this module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier /* server only */
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}

	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }

	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports

	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }

	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }

	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context = context || (this.$vnode && this.$vnode.ssrContext)
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = injectStyles
	  }

	  if (hook) {
	    // inject component registration as beforeCreate hook
	    var existing = options.beforeCreate
	    options.beforeCreate = existing
	      ? [].concat(existing, hook)
	      : [hook]
	  }

	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ },

/***/ 10:
/***/ function(module, exports) {

	module.exports = require("bfui/lib/utils/clickoutside");

/***/ },

/***/ 14:
/***/ function(module, exports) {

	module.exports = require("bfui/lib/utils/vue-popper");

/***/ },

/***/ 15:
/***/ function(module, exports) {

	module.exports = require("bfui/lib/mixins/emitter");

/***/ },

/***/ 47:
/***/ function(module, exports) {

	module.exports = require("bfui/lib/utils/resize-event");

/***/ },

/***/ 290:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _main = __webpack_require__(291);

	var _main2 = _interopRequireDefault(_main);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* istanbul ignore next */
	_main2.default.install = function (Vue) {
	  Vue.component(_main2.default.name, _main2.default);
	};

	exports.default = _main2.default;

/***/ },

/***/ 291:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(292),
	  /* template */
	  __webpack_require__(296),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)

	module.exports = Component.exports


/***/ },

/***/ 292:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _emitter = __webpack_require__(15);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _clickoutside = __webpack_require__(10);

	var _clickoutside2 = _interopRequireDefault(_clickoutside);

	var _resizeEvent = __webpack_require__(47);

	var _dropdown = __webpack_require__(293);

	var _dropdown2 = _interopRequireDefault(_dropdown);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	exports.default = {
	  mixins: [_emitter2.default],

	  name: 'ElSelectCombination',

	  componentName: 'ElSelectCombination',

	  directives: { Clickoutside: _clickoutside2.default },

	  props: {
	    // 需要展示的值, 若是单选则直接展示
	    value: {
	      required: true,
	      type: [String, Array]
	    },
	    // 是否全选
	    selectAll: {
	      default: false,
	      type: Boolean
	    },
	    disabled: Boolean,
	    placeholder: {
	      type: String,
	      default: '请选择'
	    },
	    menuVisible: {
	      type: Boolean,
	      default: false
	    }
	  },

	  data: function data() {
	    return {
	      label: '',
	      visible: this.menuVisible,
	      inputWidth: 0
	    };
	  },


	  computed: {
	    iconClass: function iconClass() {
	      return this.visible ? 'caret-top is-reverse' : 'caret-top';
	    }
	  },

	  components: {
	    DropDown: _dropdown2.default
	  },

	  watch: {
	    menuVisible: function menuVisible(v) {
	      this.visible = v;
	    },
	    value: function value() {
	      this.setLabel();
	    },
	    visible: function visible(v) {
	      this.$emit('visible-change', v);
	      if (v) {
	        this.broadcast('ElSelectCombinationDropdown', 'updatePopper');
	      } else {
	        this.broadcast('ElSelectCombinationDropdown', 'destroyPopper');
	      }
	    }
	  },

	  methods: {
	    setLabel: function setLabel() {
	      var v = this.value;
	      this.label = !Array.isArray(v) ? v : this.selectAll ? '全选' : v.length === 0 ? '' : v.length === 1 ? v[0] : v[0].substr(0, 5) + '... \u7B49' + v.length + '\u9879';
	    },
	    close: function close() {
	      this.visible = false;
	    },
	    resize: function resize() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.disabled) {
	        this.visible = !this.visible;
	      }
	    }
	  },

	  created: function created() {
	    var _this = this;

	    this.$on('closeMenu', function () {
	      _this.visible = false;
	    });
	    this.setLabel();
	  },
	  mounted: function mounted() {
	    (0, _resizeEvent.addResizeListener)(this.$el, this.resize);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.resize) (0, _resizeEvent.removeResizeListener)(this.$el, this.resize);
	  }
	};

/***/ },

/***/ 293:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(294),
	  /* template */
	  __webpack_require__(295),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)

	module.exports = Component.exports


/***/ },

/***/ 294:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _vuePopper = __webpack_require__(14);

	var _vuePopper2 = _interopRequireDefault(_vuePopper);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  name: 'ElSelectCombinationDropdown',

	  componentName: 'ElSelectCombinationDropdown',

	  mixins: [_vuePopper2.default],

	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          forceAbsolute: true,
	          gpuAcceleration: false
	        };
	      }
	    }
	  },

	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },


	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },

	  mounted: function mounted() {
	    var _this = this;

	    // 建立和父组件的映射关系, 方便在vue-tool里面查看组件结构
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//

/***/ },

/***/ 295:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "el-select-dropdown",
	    style: ({
	      minWidth: _vm.minWidth
	    })
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },

/***/ 296:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "clickoutside",
	      rawName: "v-clickoutside",
	      value: (_vm.close),
	      expression: "close"
	    }],
	    staticClass: "el-select"
	  }, [_c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.toggleMenu($event)
	      }
	    }
	  }, [_c('el-input', {
	    ref: "reference",
	    attrs: {
	      "disabled": _vm.disabled,
	      "type": "text",
	      "readonly": true,
	      "icon": _vm.iconClass,
	      "placeholder": _vm.placeholder,
	      "on-icon-click": _vm.toggleMenu
	    },
	    on: {
	      "click": _vm.toggleMenu
	    },
	    model: {
	      value: (_vm.label),
	      callback: function($$v) {
	        _vm.label = $$v
	      },
	      expression: "label"
	    }
	  })], 1), _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('drop-down', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.visible),
	      expression: "visible"
	    }]
	  }, [_vm._t("default")], 2)], 1)], 1)
	},staticRenderFns: []}

/***/ }

/******/ });